import { themeByService } from '@repo/styles';
import cn from 'classnames';
import { CSSProperties } from 'styled-components';

import { IThrillIconProps, ThrillIconVariant } from '.';

function BubbleChatThrillIcon({
  color = themeByService().color.static.adult.light,
  className,
  size = 24,
  rotate,
  flip,
  variant = ThrillIconVariant.DEFAULT,
  style,
}: IThrillIconProps) {
  const defaultStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 100,
    border: `1.2px solid ${color}`,
    background: '#FFF',
  };

  const mergedStyle = {
    width: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
    ...(variant === ThrillIconVariant.DEFAULT ? defaultStyle : {}),
    ...style,
  };
  return (
    <i className={cn('dds-icon', className, { flip })} style={mergedStyle}>
      {variant === ThrillIconVariant.DEFAULT && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          className="thrill-lighting-icon"
        >
          <path
            d="M11.5729 6.4892C11.5574 6.42203 11.5255 6.35976 11.4801 6.30795C11.4346 6.25614 11.377 6.21641 11.3125 6.19232L8.31247 5.06732L9.07289 1.24961C9.09038 1.16118 9.07908 1.06947 9.04065 0.987926C9.00222 0.906382 8.93868 0.839292 8.85935 0.796488C8.77923 0.75387 8.68727 0.738934 8.59778 0.754006C8.50829 0.769078 8.42629 0.813311 8.36455 0.879821L2.53122 7.12982C2.48342 7.17941 2.44884 7.24021 2.43064 7.30664C2.41244 7.37307 2.41121 7.443 2.42705 7.51003C2.44336 7.57682 2.47555 7.63869 2.52089 7.69037C2.56623 7.74206 2.62337 7.78203 2.68747 7.8069L5.68747 8.9319L4.92705 12.7496C4.90957 12.838 4.92087 12.9298 4.95929 13.0113C4.99772 13.0928 5.06126 13.1599 5.1406 13.2027C5.2004 13.2329 5.26633 13.2489 5.3333 13.2496C5.3899 13.2499 5.44595 13.2384 5.49792 13.216C5.5499 13.1936 5.5967 13.1607 5.63539 13.1194L11.4687 6.8694C11.5165 6.81981 11.5511 6.75902 11.5693 6.69259C11.5875 6.62616 11.5887 6.55622 11.5729 6.4892Z"
            fill={color}
          />
        </svg>
      )}
      {variant === ThrillIconVariant.ONLY_ICON && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none">
          <path
            d="M11.5729 6.4892C11.5574 6.42203 11.5255 6.35976 11.4801 6.30795C11.4346 6.25614 11.377 6.21641 11.3125 6.19232L8.31247 5.06732L9.07289 1.24961C9.09038 1.16118 9.07908 1.06947 9.04065 0.987926C9.00222 0.906382 8.93868 0.839292 8.85935 0.796488C8.77923 0.75387 8.68727 0.738934 8.59778 0.754006C8.50829 0.769078 8.42629 0.813311 8.36455 0.879821L2.53122 7.12982C2.48342 7.17941 2.44884 7.24021 2.43064 7.30664C2.41244 7.37307 2.41121 7.443 2.42705 7.51003C2.44336 7.57682 2.47555 7.63869 2.52089 7.69037C2.56623 7.74206 2.62337 7.78203 2.68747 7.8069L5.68747 8.9319L4.92705 12.7496C4.90957 12.838 4.92087 12.9298 4.95929 13.0113C4.99772 13.0928 5.06126 13.1599 5.1406 13.2027C5.2004 13.2329 5.26633 13.2489 5.3333 13.2496C5.3899 13.2499 5.44595 13.2384 5.49792 13.216C5.5499 13.1936 5.5967 13.1607 5.63539 13.1194L11.4687 6.8694C11.5165 6.81981 11.5511 6.75902 11.5693 6.69259C11.5875 6.62616 11.5887 6.55622 11.5729 6.4892Z"
            fill={color || themeByService().color.static.adult.light}
          />
        </svg>
      )}
      {variant === ThrillIconVariant.SIDE_MENU && (
        <svg viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="13" height="13" rx="6.5" fill={color} />
          <path
            d="M9.58643 6.15563C9.57599 6.11029 9.55446 6.06826 9.52379 6.03329C9.49311 5.99831 9.45423 5.9715 9.41065 5.95524L7.38564 5.19586L7.89892 2.61891C7.91073 2.55922 7.9031 2.49731 7.87716 2.44227C7.85122 2.38723 7.80833 2.34194 7.75478 2.31305C7.7007 2.28428 7.63863 2.2742 7.57822 2.28438C7.51782 2.29455 7.46247 2.32441 7.4208 2.3693L3.48328 6.58805C3.45102 6.62152 3.42767 6.66256 3.41539 6.7074C3.4031 6.75224 3.40227 6.79945 3.41297 6.84469C3.42398 6.88978 3.4457 6.93154 3.47631 6.96642C3.50691 7.00131 3.54548 7.0283 3.58875 7.04508L5.61376 7.80446L5.10047 10.3814C5.08867 10.4411 5.0963 10.503 5.12224 10.558C5.14818 10.6131 5.19106 10.6584 5.24462 10.6873C5.28498 10.7076 5.32948 10.7185 5.37469 10.7189C5.4129 10.7191 5.45073 10.7114 5.48581 10.6962C5.5209 10.6811 5.55249 10.6589 5.5786 10.631L9.51612 6.41227C9.54838 6.3788 9.57172 6.33776 9.58401 6.29292C9.59629 6.24808 9.59713 6.20087 9.58643 6.15563Z"
            fill="white"
          />
        </svg>
      )}
    </i>
  );
}

export default BubbleChatThrillIcon;
